import React from "react";
import PersonalInfo from "../Form/BusinessSignup/BusinessPersonalInfo";
import WorkInfo from "../Form/BusinessSignup/BusinessWorkInfo";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { openAlert, closeAlert } from "../../store/alert/alert";
import axios from "axios";

function BusinessSignup() {
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const baseURL = useSelector((state) => state.url.value);

  const [error, setError] = useState({});
  const [stepView, setStepView] = useState(0);

  const updateError = (error) => {
    setError(error);
    if (error.name) {
      dispatch(
        openAlert({
          title: `Validation Error - ${error.name}`,
          caption: error.message,
          type: "error",
        })
      );
      setTimeout(() => {
        dispatch(closeAlert());
      }, 4000);
    }
  };

  async function next() {
    if (stepView < steps.length - 1) {
      return setStepView(stepView + 1);
    }
    setLoading(true);
    await axios
      .post(`${baseURL}/business/add-business`, {
        ...input,
      })
      .then((res) => {
        setLoading(false);
        dispatch(
          openAlert({
            title: "Success",
            caption: res.data.message,
            type: "success",
          })
        );
        setTimeout(() => {
          dispatch(closeAlert());
        }, 4000);
        setTimeout(() => {
          window.location.reload()
        }, 2000);
      })
      .catch((err) => {
        setLoading(false);
        const res = err.response.data;
        if (res.errors) {
          dispatch(
            openAlert({
              title: res.message,
              caption: res.errors[0].msg,
              type: "error",
            })
          );
          setTimeout(() => {
            dispatch(closeAlert());
          }, 4000);
        } else if (res.error) {
          dispatch(
            openAlert({ title: res.message, caption: res.error, type: "error" })
          );
          setTimeout(() => {
            dispatch(closeAlert());
          }, 4000);
        }
      });
  }

  const setViewManually = (i) => {
    if (i < stepView) {
      setStepView(i);
    }
  };

  const steps = [{ name: "Personal Info" }, { name: "Work Info" }];
  const stepsList = steps.map((step, i) => {
    return (
      <div
        onClick={() => {
          setViewManually(i);
        }}
        className="step"
        key={step.name}
      >
        <div
          className={`${i > stepView ? "inactive" : "active"} ${
            i < stepView ? "done" : ""
          } flex flex-col`}
        >
          <p className="px-8 mb-2">{step.name}</p>
          <div className="bar bg-black h-1 w-full rounded-lg"></div>
        </div>
      </div>
    );
  });
  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  return (
    <div className="business-signup">
      <div className="steps flex items-end justify-between my-6">
        {stepsList}
      </div>
      <div className={stepView === 0 ? "" : "hidden"}>
        <PersonalInfo
          handleChange={handleChange}
          error={error}
          updateError={updateError}
          next={next}
        />
      </div>
      <div className={stepView === 1 ? "" : "hidden"}>
        <WorkInfo
          handleChange={handleChange}
          error={error}
          updateError={updateError}
          next={next}
          loading={loading}
        />
      </div>
      <p className="text-center">
        Already have an account?{" "}
        <Link to="/login" className="sys_primary">
          Sign in
        </Link>
      </p>
    </div>
  );
}

export default BusinessSignup;
